import React from 'react';
import Header from '../components/header';
import Footer from '../components/footer.js';
import { withRouter } from 'react-router-dom';

const ThankYouACHPage = () => {
	return (
		<div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50">
			<Header />
			
			{/* Success Message Section */}
			<div className="max-w-4xl mx-auto px-4 py-12">
				<div className="text-center mb-12">
					<div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-100 mb-6">
						<svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
						</svg>
					</div>
					<h1 className="text-4xl font-bold text-gray-800 mb-3">Thank You for Your Donation!</h1>
					<p className="text-lg text-gray-600">Your bank transfer donation is being processed</p>
				</div>

				{/* Email Notification Card */}
				<div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
					<div className="flex items-center justify-center mb-6">
						<div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100">
							<svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
							</svg>
						</div>
					</div>
					
					<div className="text-center">
						<h2 className="text-2xl font-semibold text-gray-800 mb-4">Check Your Email</h2>
						<p className="text-gray-600 mb-6">
							A link to view and pay your donation invoice has been sent to the email you provided.
						</p>
						<div className="bg-blue-50 rounded-lg p-4 max-w-md mx-auto">
							<p className="text-sm text-blue-800">
								Please check your inbox and follow the instructions to complete your ACH bank transfer donation.
							</p>
						</div>
					</div>
				</div>

				{/* Share Section */}
				<div className="bg-white rounded-2xl shadow-xl p-8">
					<div className="text-center mb-6">
						<h2 className="text-2xl font-semibold text-gray-800 mb-2">Help by Sharing</h2>
						<p className="text-gray-600">Spread the word and inspire others to make a difference</p>
					</div>
					
					<div className="flex justify-center gap-4">
						<button className="p-3 bg-blue-600 hover:bg-blue-700 rounded-full transition duration-200">
							<svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
								<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
							</svg>
						</button>
						
						<button className="p-3 bg-black hover:bg-gray-800 rounded-full transition duration-200">
							<svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
								<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
							</svg>
						</button>
						
						<button className="p-3 bg-blue-700 hover:bg-blue-800 rounded-full transition duration-200">
							<svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
								<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
							</svg>
						</button>
						
						<button className="p-3 bg-gray-600 hover:bg-gray-700 rounded-full transition duration-200">
							<svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
							</svg>
						</button>
					</div>
				</div>
			</div>
			
			<Footer />
		</div>
	);
}

export default withRouter(ThankYouACHPage);
